import { tns, TinySliderInstance } from "tiny-slider/src/tiny-slider";

interface FeaturedNewsCarousel {
  root: HTMLElement;
  bannersWrapper: HTMLElement | null;
  articlesWrapper: HTMLElement | null;
  articles: HTMLElement[];
}

const featuredNewsCarousels = (): FeaturedNewsCarousel[] =>
  [...document.querySelectorAll(".js-featured-news-carousel")].map(
    (root): FeaturedNewsCarousel => {
      return {
        root: <HTMLElement>root,
        bannersWrapper: root.querySelector(
          ".js-featured-news-carousel-banners"
        ),
        articlesWrapper: root.querySelector(
          ".js-featured-news-carousel-articles"
        ),
        articles: [
          ...(<NodeListOf<HTMLElement>>(
            root.querySelectorAll(".js-featured-news-carousel-article")
          )),
        ],
      };
    }
  );

const initializeFeaturedNewsCarousels = (): TinySliderInstance[] =>
  featuredNewsCarousels().map((featuredNewsCarousel) => {
    if (
      !(featuredNewsCarousel.bannersWrapper instanceof Element) ||
      !(featuredNewsCarousel.articlesWrapper instanceof Element)
    ) {
      throw Error("Could not initialize featured news carousel.");
    }

    const slider = tns({
      mode: "carousel",
      container: featuredNewsCarousel.bannersWrapper,
      items: 1,
      controls: false,
      navAsThumbnails: true,
      navContainer: featuredNewsCarousel.articlesWrapper,
      mouseDrag: true,
    });

    featuredNewsCarousel.articles.forEach((article) => {
      article.addEventListener("mouseenter", () => {
        slider.goTo(Number(article.dataset.nav));
      });
    });

    return slider;
  });

initializeFeaturedNewsCarousels();
